// Vệt mực (UI_SPEC §10.4): cách duy nhất in một con số đơn lên mặt màn (Lực Chiến…). Dáng blob sinh
// từ seed cố định theo tên chỉ số (FNV-1a → mulberry32), cache theo seed.
import type { JSX } from 'preact';
import { createRng, fnv1a } from '@sim/core/rng';

const cache = new Map<string, string[]>();

function blob(seed: string, w: number, h: number, spread: number): string {
  const rng = createRng(fnv1a(seed));
  const n = 11 + rng.int(4);
  const pts: [number, number][] = [];
  for (let i = 0; i < n; i++) {
    const a = (i / n) * Math.PI * 2;
    const r = 0.78 + rng.next() * 0.3 * spread;
    pts.push([w / 2 + Math.cos(a) * (w / 2) * r * 0.92, h / 2 + Math.sin(a) * (h / 2) * r * 0.82]);
  }
  // Catmull-Rom khép kín → Bézier bậc 3.
  let d = `M${pts[0]![0].toFixed(1)} ${pts[0]![1].toFixed(1)}`;
  for (let i = 0; i < n; i++) {
    const p0 = pts[(i - 1 + n) % n]!;
    const p1 = pts[i]!;
    const p2 = pts[(i + 1) % n]!;
    const p3 = pts[(i + 2) % n]!;
    const c1 = [p1[0] + (p2[0] - p0[0]) / 6, p1[1] + (p2[1] - p0[1]) / 6];
    const c2 = [p2[0] - (p3[0] - p1[0]) / 6, p2[1] - (p3[1] - p1[1]) / 6];
    d += ` C${c1[0]!.toFixed(1)} ${c1[1]!.toFixed(1)} ${c2[0]!.toFixed(1)} ${c2[1]!.toFixed(1)} ${p2[0].toFixed(1)} ${p2[1].toFixed(1)}`;
  }
  return `${d}Z`;
}

function shapes(seed: string): string[] {
  let s = cache.get(seed);
  if (!s) {
    s = [blob(`${seed}|a`, 78, 60, 1.4), blob(`${seed}|b`, 72, 54, 1), blob(`${seed}|c`, 66, 48, 0.7)];
    cache.set(seed, s);
  }
  return s;
}

export function InkStat(props: {
  seed: string;
  value: string;
  label?: string;
  id?: string;
  class?: string;
}): JSX.Element {
  const [a, b, c] = shapes(props.seed);
  return (
    <div class={`ht-ink${props.class ? ` ${props.class}` : ''}`} data-id={props.id}>
      <svg viewBox="0 0 78 60" aria-hidden="true">
        <path d={a} fill="#f7f1e0" opacity=".17" />
        <path d={b} fill="#6d7a75" opacity=".5" transform="translate(3 3)" />
        <path d={c} fill="#04080b" opacity=".96" transform="translate(6 6)" />
      </svg>
      <b>{props.value}</b>
      {props.label && <small>{props.label}</small>}
    </div>
  );
}
